import { render, staticRenderFns } from "./AddIntGoods.vue?vue&type=template&id=d492ff34&scoped=true"
import script from "./AddIntGoods.vue?vue&type=script&lang=js"
export * from "./AddIntGoods.vue?vue&type=script&lang=js"
import style0 from "./AddIntGoods.vue?vue&type=style&index=0&id=d492ff34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d492ff34",
  null
  
)

export default component.exports